<nes-tile-container class="nes-h-full" full-media="false" filled="false">
  <div
    [relay42]="{ label: AccountType[type] }"
    (click)="navigate(AccountType[type])"
    (keydown.enter)="navigate(AccountType[type])"
  >
    <div class="nes-flex-col">
      <div class="nes-flex nes-w-full nes-items-center nes-justify-between nes-mb-3">
        <div class="nes-flex nes-items-center">
          <nes-icon class="nes-pr-4" [name]="iconName" color="text-default"></nes-icon>
          <div>
            <nes-heading [size]="'xl'" color="blue" weight="bold">{{ type | translate }}</nes-heading>
            <nes-text color="gray-400" class="">{{ type === 'CONTACT_PERSON' ? ('LOGIN.CHOOSE_ACCOUNT.CONTACT_PERSON_HELP_TEXT' | translate) : ('LOGIN.CHOOSE_ACCOUNT.CARD_HOLDER_HELP_TEXT' | translate) }}</nes-text>
          </div>
        </div>

        <nes-icon class="icon-right nes-pr-2" name="chevron-right" color="text-default"></nes-icon>
      </div>
      <nes-text class="nes-w-full sm:nes-w-3/4">{{ description | translate }}</nes-text>
    </div>
  </div>
</nes-tile-container>
